import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

class ComplexityFactorForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      complexityQuestions: [],
      complexityAnswersUnmodified: [],
      complexityAnswersSelected: [],
      shouldContinueSettingValues: true,
    };

    this.onModalReset = this.onModalReset.bind(this);
    this.onModalSave = this.onModalSave.bind(this);
    this.handleLeedChange = this.handleLeedChange.bind(this);
    this.handleYesNoChange = this.handleYesNoChange.bind(this);
    this.SetComplexityValuesForModal = this.SetComplexityValuesForModal.bind(this);
    this.onYearBuiltChanged = this.onYearBuiltChanged.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.complexityQuestions.length > 0 &&
      this.props.complexityQuestions !== prevProps.complexityQuestions
    ) {
      this.props.complexityQuestions.forEach((pc) => {
        pc.yesNoAnswer = null;
        pc.yearBuiltAnswer = "";
        pc.leedCertificationId = "";
      });

      this.setState(() => ({
        complexityQuestions: this.props.complexityQuestions,
        complexityAnswersUnmodified: JSON.parse(
          JSON.stringify(this.props.complexityQuestions)
        ),
      }));
    }

    if (
      this.props.complexityAnswers.length > 0 &&
      this.props.complexityAnswers !== prevProps.complexityAnswers
    ) {
      this.setState(() => ({
        complexityAnswersSelected: this.props.complexityAnswers,
      }));
    }

    if (this.state.shouldContinueSettingValues) {
        debugger;
      this.SetComplexityValuesForModal();
    }
  }

  SetComplexityValuesForModal() {
    var complexityAnswersCurrent = this.state.complexityQuestions;
    var complexityAnswersSelected = this.state.complexityAnswersSelected;

    if (
      !complexityAnswersCurrent ||
      complexityAnswersCurrent.length < 1 ||
      !complexityAnswersSelected ||
      complexityAnswersSelected.length < 1
    ) {
      console.log("actual complexity values fail early");
      return;
    }

    complexityAnswersCurrent.forEach(pc => { pc.yesNoAnswer = null;
        pc.yearBuiltAnswer = "";
        pc.leedCertificationId = "";});

    complexityAnswersSelected.forEach((e) => {
      var currentIndex = complexityAnswersCurrent.findIndex(
        (pc) => pc.complexityId === e.complexityId
      );
      if (currentIndex > -1) {
        complexityAnswersCurrent[currentIndex].yesNoAnswer =
          e.yesNoAnswer === null ? null : e.yesNoAnswer;
          complexityAnswersCurrent[currentIndex].yearBuiltAnswer =
          e.yearBuiltAnswer === null ? "" : e.yearBuiltAnswer;
          complexityAnswersCurrent[currentIndex].leedCertificationId =
          e.leedCertificationId === null ? "" : e.leedCertificationId;
      }
    });

    this.setState(() => ({
        complexityQuestions: complexityAnswersCurrent,
      complexityAnswersUnmodified: JSON.parse(
        JSON.stringify(complexityAnswersCurrent)
      ),
      shouldContinueSettingValues: false
    }));
  }

  getLeedOptions() {
    return this.props.leedOptions.map((leed) => {
      return {
        label: leed.certificationLevel,
        value: leed.leedCertificationId,
      };
    });
  }

  handleLeedChange(complexityId, leedId) {
    var newComplexityAnswerList = JSON.parse(
      JSON.stringify(this.state.complexityQuestions)
    ); //deep copy
    var currentIndex = newComplexityAnswerList.findIndex(
      (pc) => pc.complexityId === complexityId
    );

    newComplexityAnswerList[currentIndex].leedCertificationId = leedId;

    this.setState({
        complexityQuestions: newComplexityAnswerList,
    });
  }

  handleYesNoChange(complexityId, newYesNoValue) {
    var newComplexityAnswerList = JSON.parse(
      JSON.stringify(this.state.complexityQuestions)
    ); //deep copy
    var currentIndex = newComplexityAnswerList.findIndex(
      (pc) => pc.complexityId === complexityId
    );

    newComplexityAnswerList[currentIndex].yesNoAnswer = newYesNoValue == "true";

    debugger;

    this.setState({
        complexityQuestions: newComplexityAnswerList,
    });
  }

  onYearBuiltChanged(complexityId, yearBuilt) {
    var newComplexityAnswerList = JSON.parse(
      JSON.stringify(this.state.complexityQuestions)
    ); //deep copy
    var currentIndex = newComplexityAnswerList.findIndex(
      (pc) => pc.complexityId === complexityId
    );

    newComplexityAnswerList[currentIndex].yearBuiltAnswer = parseInt(yearBuilt);

    this.setState({
        complexityQuestions: newComplexityAnswerList,
    });
  }

  onModalReset() {
    if (this.state.complexityAnswersUnmodified) {
      var originalComplexity = JSON.parse(
        JSON.stringify(this.state.complexityAnswersUnmodified)
      );
      this.setState({ complexityQuestions: originalComplexity });
    }
  }

  onModalSave() {     
    var complexity = this.state.complexityQuestions;
    this.props.onSubmit(complexity);
    this.props.onModalClose();
  }

  render() {
    const tableHeaderStyle = {
      textAlign: "center",
    };

    return (
      <form className="modal-form">
        <div className="table-wrap" id="complexity">
          <table className="uomTable">
            <thead>
              <tr>
                <th style={tableHeaderStyle}>Complexity</th>
                <th style={tableHeaderStyle}>Answer</th>
                <th style={tableHeaderStyle}>Instructions</th>
              </tr>
            </thead>
            <tbody>
              {this.state.complexityQuestions &&
                this.state.complexityQuestions.map((pc, index) => {
                  return (
                    <tr key={index}>
                      <td>{pc.complexityName}</td>

                      <td>
                        {pc.complexityId == 2 ? (
                          <input
                            type="number"
                            name="yearBuilt"
                            id="yearBuilt"
                            value={pc.yearBuiltAnswer}
                            min="0"
                            autoComplete="off"
                            onChange={(e) =>
                              this.onYearBuiltChanged(
                                pc.complexityId,
                                e.target.value
                              )
                            }
                          />
                        ) : pc.complexityId == 8 ? (
                          <Select
                            name="leedCertification"
                            value={pc.leedCertificationId}
                            options={this.getLeedOptions()}
                            onChange={(e) =>
                              this.handleLeedChange(pc.complexityId, e.value)
                            }
                          />
                        ) : (
                          <div className="cRadios">
                            <input
                              type="radio"
                              id={pc.complexityId + "yes"}
                              name={pc.complexityId + "yesNo"}
                              value="true"
                              checked={pc.yesNoAnswer == true}
                              onChange={(e) =>
                                this.handleYesNoChange(
                                  pc.complexityId,
                                  e.target.value
                                )
                              }
                            />
                            <label
                              htmlFor={pc.complexityId + "yes"}
                              className="radioLabel"
                            >
                              Yes
                            </label>
                            <input
                              type="radio"
                              id={pc.complexityId + "no"}
                              name={pc.complexityId + "yesNo"}
                              className="radioNo"
                              value="false"
                              checked={pc.yesNoAnswer == false}
                              onChange={(e) =>
                                this.handleYesNoChange(
                                  pc.complexityId,
                                  e.target.value
                                )
                              }
                            />
                            <label
                              htmlFor={pc.complexityId + "no"}
                              className="radioLabel"
                            >
                              No
                            </label>
                          </div>
                        )}
                      </td>

                      <td>{pc.instructions}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <div className="actions">
          <button
            type="button"
            className="btn-update btn-update-custom"
            onClick={this.onModalReset}
          >
            UNDO
          </button>
          <button
            type="button"
            className="btn-update btn-update-custom"
            onClick={() => this.onModalSave()}
          >
            SAVE
          </button>
        </div>
      </form>
    );
  }
}

ComplexityFactorForm.propTypes = {
  complexityQuestions: PropTypes.array.isRequired,
  leedOptions: PropTypes.array.isRequired,
  complexityAnswers: PropTypes.array.isRequired,
  onModalClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default ComplexityFactorForm;
